import {
  ChartColumn,
  Download,
  House,
  LayoutGrid,
  List,
  Settings,
  WalletCards,
} from "lucide-react";
import type { ComponentType } from "react";

export interface NavItem {
  to: string;
  label: string;
  icon: ComponentType<{ size?: number; strokeWidth?: number; "aria-hidden"?: boolean }>;
}

export const fullNav: NavItem[] = [
  { to: "/budget", label: "Budget", icon: LayoutGrid },
  { to: "/reports", label: "Reports", icon: ChartColumn },
  { to: "/import", label: "Import", icon: Download },
];

export const settingsNav: NavItem = { to: "/settings", label: "Settings", icon: Settings };

export const phoneTabs: NavItem[] = [
  { to: "/", label: "Home", icon: House },
  { to: "/accounts", label: "Accounts", icon: WalletCards },
  { to: "/activity", label: "Activity", icon: List },
];
